import * as React from "react"
import { useState } from "react"
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'

import { h3, body, bodyLarge } from "../commonStyles/Fonts";

import { styled } from "../../stitches.config"
import Link from "../../components/Link";

import { resetPasswordToken } from "../../api/account"
import { useQuery } from "../pages/SearchPage";

type ResetPassportTokenFormValues = {
    password: string,
    password_repeat: string;
}

// TODO animacja submitowania/ostylować błędy logowania/informacja o sprawdzeniu skrzynki email
const ResetPasswordToken: React.FC = () => {
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [submitted, setSubmitted] = useState<boolean>(false)
    const initialValues: ResetPassportTokenFormValues = { password: "", password_repeat: "" }
    const validationSchema = Yup.object().shape({
        password: Yup.string()
            .required("Pole wymagane"),
        password_repeat: Yup.string()
            .required("Pole wymagane"),
    })

    const query = useQuery();
    const token = query.get("token") || "";

    const handleSubmit = ({ password, password_repeat }: ResetPassportTokenFormValues, { setErrors }: { setErrors: any }) => {
        setSubmitting(true)
        resetPasswordToken({ password, password_repeat, token })
            .then(res => {
                console.log(res)
                setSubmitted(true)
            })
            .catch(err => {
                console.log(err)
                setSubmitting(false)
                setErrors(err.errors || [])
            })
    }

    return <Overlay>
        <FormWrapper>
            {submitted ? <div>hasło zmienione</div> :
                <>
                    <FormTitle>
                        <p className={h3()}>Utwórz nowe hasło</p>
                    </FormTitle>
                    <FormText className={bodyLarge()}>Wpisz dwukrotnie nowe hasło.</FormText>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}>
                        {({ errors, touched }) => (
                            <Form className={body()}>
                                <label className={`${errors.password && touched.password && "show-error-input-text"}`} htmlFor="password">Hasło</label>
                                <Field
                                    type="password"
                                    name="password"
                                    className={`${bodyLarge()} ${errors.password && touched.password && "show-error-input-border"}`}
                                    disabled={submitting}
                                    placeholder="Hasło" />
                                {errors.password && touched.password && <span className="validationError">{errors.password}</span>}

                                <label className={`${errors.password_repeat && touched.password_repeat && "show-error-input-text"}`} htmlFor="password_repeat">Powrórz hasło</label>
                                <Field
                                    type="password"
                                    name="password_repeat"
                                    className={`${bodyLarge()} ${errors.password_repeat && touched.password_repeat && "show-error-input-border"}`}
                                    disabled={submitting}
                                    placeholder="Powtórz hasło" />
                                {errors.password_repeat && touched.password_repeat && <span className="validationError">{errors.password_repeat}</span>}

                                <button
                                    type="submit"
                                    className={bodyLarge()}
                                    disabled={submitting}>
                                    Zapisz
                                </button>
                            </Form>
                        )}
                    </Formik>
                </>}
            <FormWrapperLink className={bodyLarge()}>
                <Link to="/login">
                    Wróć do logowania
                </Link>
            </FormWrapperLink>
        </FormWrapper>
    </Overlay>
}

const Overlay = styled("div", {
    position: "relative",
    backgroundColor: "white",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    minHeight: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "$grayscale10",
    "@bp2": {
        padding: "72px 0 80px 0",
    }
})

const FormTitle = styled("div", {
    "& p": {
        width: "332px",
        margin: 0,
    },
})

const FormText = styled("p", {
    width: "332px",
    margin: "8px 0 0 0",
    "& span": {
        color: "$primary",
    }
})

const FormWrapper = styled("div", {
    padding: "32px 16px 32px 16px",
    color: "$grayscale100",
    background: "$grayscale0",
    "@bp2": {
        width: "auto",
        padding: "36px 40px 32px 40px",
    },
    "& form": {
        display: "flex",
        flexDirection: "column",
        "& label": {
            margin: "24px 0 4px 0"
        },
        "& input": {
            border: "1px solid $grayscale25",
            caretColor: "$primary",
            color: "$grayscale100Fixed",
            "&:hover": {
                border: "1px solid $grayscale50",
            },
            "&:focus": {
                border: "1px solid $grayscale50",
            },
            "&::placeholder": {
                color: "$grayscale50",
            },
        },
        "& input, button": {
            fontWeight: "500",
            padding: "12px 14px",
            transition: "0.2s",
        },
        "& button": {
            background: "$primary",
            borderWidth: "0px",
            color: "$grayscale0",
            margin: "24px 0",
        },
        "& a": {
            color: "$grayscale75",
            marginTop: "6px",
            textDecoration: "underline",
            "& span": {
                fontSize: "12px",
                lineHeight: "16px",
            }
        }
    },
    "& .validationError": {
        color: "$aszdziennikPrimary",
        fontSize: "12px",
        lineHeight: "16px",
        marginTop: "8px",
    },
    ".show-error-input-border": {
        border: "1px solid $aszdziennikPrimary",
        "&:hover": {
            border: "1px solid $aszdziennikPrimary",
        },
        "&:focus": {
            border: "1px solid $aszdziennikPrimary",
        },
    },
    ".show-error-input-text": {
        color: "$aszdziennikPrimary",
    }
})

const FormWrapperLink = styled("div", {
    width: "100%",
    display: "flex",
    "& a": {
        margin: "0 auto",
        color: "$grayscale100",
        "& span": {
            color: "$primary",
        },
        "&:hover": {
            textDecoration: "none",
        }
    }
})

export default ResetPasswordToken